export default __webpack_public_path__ + "7e480d8e917ae5b61f75f49ca7f32cbf.svg";